import React from 'react';

export interface EventAction {
  EventItemId: number;
  EventItemActionName: string | null;
  EventItemPassedFlag: number | null;
  EventItemPassedFlagName: string | null;
  EventItemTally: string | null;
  EventItemMover: string | null;
  EventItemSeconder: string | null;
  EventItemVersion: string | null;
  EventItemAgendaSequence: number | null;
}

interface ActionTimelineProps {
  actions: EventAction[];
}

const ActionTimeline: React.FC<ActionTimelineProps> = ({ actions }) => {
  if (actions.length === 0) return null;

  // Sort by agenda sequence
  const sorted = [...actions].sort(
    (a, b) => (a.EventItemAgendaSequence ?? 0) - (b.EventItemAgendaSequence ?? 0)
  );

  return (
    <div>
      <h4 className="text-sm font-semibold text-gray-700 mb-2">Actions at this hearing:</h4>
      <div className="space-y-1.5">
        {sorted.map((action) => (
          <div key={action.EventItemId} className="flex items-start gap-2 text-sm">
            <span className="text-gray-400 mt-0.5 flex-shrink-0">&bull;</span>
            {action.EventItemVersion && (
              <span
                className={`flex-shrink-0 px-1.5 py-0.5 rounded text-xs font-medium ${
                  action.EventItemVersion === '*'
                    ? 'bg-gray-100 text-gray-600'
                    : 'bg-blue-100 text-blue-800'
                }`}
                title={action.EventItemVersion === '*' ? 'Original version' : `Amended version ${action.EventItemVersion}`}
              >
                {action.EventItemVersion === '*' ? 'Ver. *' : `Ver. ${action.EventItemVersion}`}
              </span>
            )}
            <span className="text-gray-800">
              {action.EventItemActionName || 'No action recorded'}
            </span>
            {action.EventItemPassedFlagName && (
              <span
                className={`flex-shrink-0 px-1.5 py-0.5 rounded text-xs font-medium ${
                  action.EventItemPassedFlag === 1
                    ? 'bg-green-100 text-green-800'
                    : action.EventItemPassedFlag === 0
                    ? 'bg-red-100 text-red-800'
                    : 'bg-gray-100 text-gray-700'
                }`}
              >
                {action.EventItemPassedFlagName}
              </span>
            )}
            {action.EventItemTally && (
              <span className="flex-shrink-0 text-xs text-gray-500">
                ({action.EventItemTally})
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActionTimeline;
